<template>
  <NuxtNotifications
      group="createAd"
      position="center center"
      :max="1"
      dangerously-set-inner-html
      width="300"
      :speed="100"
      classes="create-notification"
  >
    <template #body="props">
      <div class="create-notification__wrapper">
        <div class="create-notification__icon" :class="[props.class]">
          <svg
              class="svg-icon-success" width="800px" height="800px" viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg">
            <g data-name="Layer 2" id="Layer_2">
              <g
                  data-name="E408, Success, Media, media player, multimedia"
                  id="E408_Success_Media_media_player_multimedia">
                <circle class="svg-icon-success__element" cx="256" cy="256" r="246" />
                <polyline class="svg-icon-success__element" points="115.54 268.77 200.67 353.9 396.46 158.1" />
              </g>
            </g>
          </svg>
        </div>
        <p class="create-notification__title" v-if="props.item.title">
          {{ props.item.title }}
        </p>

        <div class="create-notification__text" v-html="props.item.text" />

        <UButton
            class="create-notification__close"
            size="md"
            :ui="{
              color: {
                primary: {
                  solid:
                    'bg-[#1774ff] w-[60px] text-white hover:bg-[#1745ff] transition-color duration-[.4s] justify-center',
                },
              },
            }"
            @click="props.close"
        >
          {{$t('ok')}}
        </UButton>
      </div>
    </template>
  </NuxtNotifications>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.svg-icon-success {
  &__element {
    fill: none;
    stroke:  #28a745;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 20px;
  }
}

.create-notification {
  &__close {
    align-self: flex-end;
  }
  &__title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin: 0;
    text-align: center;
  }

  &__text {
    font-size: 16px;
    color: #555;
    text-align: center;
    margin: 0;
  }
  &__wrapper {
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px;
    border-radius: 12px;
    width: 500px;
    gap: 24px;
  }
  &__icon {
    width: 100px;
    height: 100px;
    > svg {
      width: 100%;
      height: 100%;
      display: none;
    }

    &.success {
      .svg-icon-success {
        display: inherit;
      }
    }
  }
}
</style>
